import { rem } from '../../utils/utils';

const Tabletheme = {
  baseStyle: () => {
    return {
      caption: {
        marginBottom: '12',
        textAlign: 'left',
      },
      captionDescription: {
        color: 'pal.neutral.30',
        marginTop: '4',
      },
      captionTitle: {
        color: 'pal.purple.10',
        fontSize: '4',
        fontWeight: 'bold',
        lineHeight: '1.75rem',
      },
      expandTd: {
        borderBottomColor: 'transparent',
        paddingRight: 0,
        width: '1%',
      },
      sortButton: {
        _hover: {
          backgroundColor: 'pal.neutral.90',
        },
        alignItems: 'center',
        display: 'flex',
        fontWeight: 'bold',
        gap: '8',
        paddingX: '16',
        paddingY: '12',
        textAlign: 'left',
        width: '100%',
      },
      sortIcon: {
        '[aria-sort="ascending"] & path:first-of-type': {
          fill: 'pal.purple.10',
        },
        '[aria-sort="descending"] & path:last-of-type': {
          fill: 'pal.purple.10',
        },
        '[aria-sort="none"]:hover & path': {
          fill: 'pal.purple.10',
        },
        path: {
          fill: 'pal.neutral.80',
        },
      },
      table: {
        '&:not(.disable-row-hover)': {
          tr: {
            _hover: {
              td: { backgroundColor: 'pal.neutral.95' },
            },
          },
        },
        borderCollapse: 'separate',
        borderColor: 'border/minimal',
        borderRadius: '4',
        borderSpacing: 0,
        borderStyle: 'solid',
        borderWidth: '1px',
        fontVariantNumeric: 'lining-nums tabular-nums',
        width: '100%',
      },
      td: {
        backgroundColor: 'pal.neutral.100',
        borderTopColor: 'pal.neutral.93',
        borderTopStyle: 'solid',
        borderTopWidth: '1px',
        height: rem(65),
        paddingX: '16',
        paddingY: '8',
        textAlign: 'left',
        textStyle: 'body/md/regular',
      },
      th: {
        fontWeight: 'bold',
        paddingX: '16',
        paddingY: '12',
        textAlign: 'left',
        textStyle: 'heading/h5',
        whiteSpace: 'nowrap',
      },
      thead: {
        backgroundColor: 'pal.neutral.93',
        borderTopLeftRadius: '4',
        borderTopRightRadius: '4',
      },
      tooltipContainer: {
        alignItems: 'center',
        display: 'flex',
        gap: 4,
      },
    };
  },
  variants: {
    borderless: {
      table: {
        border: 'none',
      },
      td: {
        _first: {
          paddingLeft: '12',
        },
        _last: {
          paddingRight: '12',
        },
        borderColor: 'border/regular',
      },
      th: {
        _first: {
          paddingLeft: '12',
        },
        _last: {
          paddingRight: '12',
        },
        borderColor: 'border/regular',
      },
      thead: {
        backgroundColor: 'transparent',
      },
    },
    card: {
      table: {
        border: 'none',
      },
      td: {
        _first: {
          paddingLeft: '24',
        },
        _last: {
          paddingRight: '24',
        },
      },
      th: {
        _first: {
          paddingLeft: '24',
        },
        _last: {
          paddingRight: '24',
        },
      },
      thead: {
        backgroundColor: 'transparent',
      },
    },
  },
};

export default Tabletheme;
